var map = {
	"./2022-06-11-banner00.json": "1fd0",
	"./2022-06-11-banner02.json": "fa7d",
	"./2022-06-11-banner03.json": "5b26",
	"./2022-06-11-banner04.json": "00ab",
	"./2022-06-11-banner05.json": "124d",
	"./2022-06-11-banner06.json": "50f0",
	"./2022-06-12-banner-08.json": "ebab",
	"./2022-06-12-vai.json": "f9cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04df";